import { useTranslation } from 'react-i18next'

import {
  QA_NAME_SHOW_LESS_BUTTON,
  QA_NAME_SHOW_MORE_BUTTON,
} from '../../../../constants/qa'
import { useReadMore } from '../../../../hooks'
import { getQaSelector } from '../../../../utils/common'
import { Avatar, AVATAR_HEIGHT_40 } from '../../../Avatar'
import Button, { BUTTON_HEIGHT_24, ButtonArrow } from '../../../Button'
import Text from '../../../Text'
import {
  ENTITY_PROFILE_TAB_UPDATES_TEXT_MAX_LINES,
  QA_NAME_ENTITY_PROFILE_TAB_UPDATES_CARD,
} from '../EntityProfileTabUpdates.constants'
import {
  getEntityProfileTabUpdateOwnerType,
  isEntityProfileTabUpdateOwnerDeleted,
  isEntityProfileTabUpdateOwnerSystem,
} from '../EntityProfileTabUpdates.utils'
import { EntityProfileTabUpdatesCardHeader } from '../EntityProfileTabUpdatesCardHeader'

import { getEntityProfileTabUpdateAvatarProps } from './EntityProfileTabUpdatesCard.utils'

import * as styles from './EntityProfileTabUpdatesCard.module.css'

function EntityProfileTabUpdatesCard({
  deletedOwnerNameKey,
  ref,
  systemOwnerNameKey,
  value,
}) {
  const { t } = useTranslation()

  const owner = value?.owner_obj
  const type = getEntityProfileTabUpdateOwnerType(owner)

  const isSystem = isEntityProfileTabUpdateOwnerSystem(type)
  const isDeleted = isEntityProfileTabUpdateOwnerDeleted(type)
  const isInteractive = !isSystem && !isDeleted

  const avatarProps = getEntityProfileTabUpdateAvatarProps({ owner, type })

  const { handleClickReadMore, isReadMore, showReadMore, textRef } =
    useReadMore({
      maxLines: ENTITY_PROFILE_TAB_UPDATES_TEXT_MAX_LINES,
      textData: value?.text,
    })

  const qaProps = getQaSelector({
    value: QA_NAME_ENTITY_PROFILE_TAB_UPDATES_CARD,
  })

  return (
    <div {...qaProps} className={styles.card} ref={ref}>
      <Avatar
        {...avatarProps}
        className={styles.avatar}
        size={AVATAR_HEIGHT_40}
      />
      <div className={styles.content}>
        <EntityProfileTabUpdatesCardHeader
          deletedOwnerNameKey={deletedOwnerNameKey}
          isInteractive={isInteractive}
          owner={owner}
          systemOwnerNameKey={systemOwnerNameKey}
          timestamp={value?.timestamp}
          type={type}
        />
        <Text Element='div' className={styles.text} ref={textRef}>
          {value?.content ?? value?.text}
        </Text>
        {showReadMore ? (
          <ButtonArrow
            isGrey
            Button={Button.Contained}
            className={styles.readMoreButton}
            height={BUTTON_HEIGHT_24}
            isOpen={isReadMore}
            qaName={
              isReadMore ? QA_NAME_SHOW_LESS_BUTTON : QA_NAME_SHOW_MORE_BUTTON
            }
            text={
              isReadMore
                ? t('Common.ShowLessBtnKey')
                : t('Common.ReadMoreBtnKey')
            }
            onClick={handleClickReadMore}
          />
        ) : null}
      </div>
    </div>
  )
}

export default EntityProfileTabUpdatesCard
